import React from 'react';

const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.querySelector(sectionId);
    if (element) {
      element.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <section className="hero-section min-h-[700px] flex items-center pt-24">
      <div className="container mx-auto px-6 w-full">
        <div className="max-w-2xl">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight mb-6">
            We Help Small & Mid-Size Businesses Streamline Operations & Grow with Smart Technology
          </h1>
          <p className="text-xl text-gray-700 mb-8">
            You have bottlenecks. We design tech systems to remove them. Business systems & automation — not just code.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <button 
              onClick={() => scrollToSection('#contact')}
              className="px-8 py-3 bg-primary text-white font-medium !rounded-button hover:bg-primary/90 transition-all transform hover:-translate-y-1 shadow-lg hover:shadow-xl whitespace-nowrap"
            >
              Discover Your Solution
            </button>
            <button 
              onClick={() => scrollToSection('#services')}
              className="px-8 py-3 bg-white text-primary border border-primary font-medium !rounded-button hover:bg-gray-50 transition-all transform hover:-translate-y-1 whitespace-nowrap"
            >
              See How We Help
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
